(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/thunks/pay-game.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/thunks/pay-game.js');

'use strict';

const PAYMENT_SUCCESS = svs.tur.payment.constants.events.PAYMENT_SUCCESS;
const Pay = svs.tur.payment.api.jupiter.fractiongames.Pay;
const PaymentError = svs.tur.payment.dialogs.PaymentError;
const FormatTime = svs.utils.date.FormatTime;
const {
  productMapping,
  draws: {
    drawsApi
  }
} = svs.numbergames;
const payGame = (containerId, onPaymentSuccess) => (dispatch, getState) => {
  const container = getState().containers[containerId];
  if (container) {
    const {
      activatedDrawId,
      containerId,
      productNumeric,
      sharePrice,
      totalShares
    } = container;
    const productName = productMapping.getProductName(productNumeric);
    const nextRegOpenTime = drawsApi.nextRegOpenTime(productNumeric);
    const payment = new Pay({
      productName,
      productNumeric,
      price: parseInt(sharePrice, 10),
      drawId: activatedDrawId,
      sharesTotal: totalShares,
      containerId
    });
    if (onPaymentSuccess) {
      payment.on(PAYMENT_SUCCESS, onPaymentSuccess);
    }
    payment.on('payment:error:apierror:draw_closed', () => {
      new PaymentError({
        errorTitle: 'Hoppsan!',
        errorMessage: "Andelsspelet p\xE5 ".concat(productName, " finns inte l\xE4ngre tillg\xE4ngligt.<br /><br />\n          F\xF6rs\xE4ljning av andelar p\xE5 ").concat(productName, " \xF6ppnar f\xF6r f\xF6rs\xE4ljning igen<br />\n          <span class=\"f-bold\">kl.").concat(FormatTime('HH:mm', nextRegOpenTime), ".</span> ")
      });
    });
    payment.initialize();
  }
};
svs.numbergames.fractiongames.redux.thunks.payGame = payGame;

 })(window);